import { CheckPatientByEmail } from 'domain/usecases/patient/check-patient-by-email'
import { PatientRepository } from 'repository/interfaces/patient-repository'

export class RemoteCheckPatientByEmail implements CheckPatientByEmail {
  private readonly patientRepository: PatientRepository

  constructor(patientRepository: PatientRepository) {
    this.patientRepository = patientRepository
  }

  check(email: string): Promise<CheckPatientByEmail.Model> {
    return this.patientRepository.checkPatientByEmail(email)
  }
}
